import { serviceApi } from '../service';

export const sessionUrl = 'session';

export const createSession = () => serviceApi.fetch(sessionUrl, { method: 'POST' });

export const sessionApi = {
  createSession,
};
